// extracted by mini-css-extract-plugin
export default {"AppTabs":"AppTabs_AppTabs__3NWO0","selected":"AppTabs_selected__io7Wc"};